import React, { useEffect } from "react";
import { useChair } from "../../../context/ChairContext";
import { ChairVariantInfo, useGetChairInformation } from "../../../api/hooks/useChairs";
import { ChairInfoButton } from "../ChairInfoButton";
import { usePDFContext } from "../../../context/PDFContext";
import { useGetGlobalNote } from "../../../api/hooks/useNotes";

type ChairInfoProps = {
    chairInfo: ChairVariantInfo;
};

const ChairInfo = (props: ChairInfoProps) => {
    const info = props.chairInfo;
    const { chair } = useChair();
    const setChairInfo = usePDFContext((state) => state.setChairInfo);

    const globalNoteQuery = useGetGlobalNote();
    const globalNote = globalNoteQuery.isSuccess ? globalNoteQuery.data.globalsEntries[0] : null;

    useEffect(() => {
        if (props.chairInfo) {
            setChairInfo(props.chairInfo);
        }
    }, [props.chairInfo]);

    return (
        <>
            <h2>{`${info.categories.includes("bench") ? "Ihre" : "Ihr"} ${info.parent.chairName} ${info.variantName}`}</h2>
            <ul className={"selection"}>
                <li className={"measurements"}>{info.measurements.replace(/ cm/g, "cm")}</li>
                <li className={"material"}>
                    {info.fabricLFM ? `Stoff: ${info.fabricLFM}lfm` : null} |{" "}
                    {info.leatherM2 ? `Leder: ${info.leatherM2}m²` : null}
                </li>
                <li className={"placeholder"}></li>
                {chair.frame ? (
                    <li>
                        <span>{`Gestell: ${chair.frame.name}`}</span>
                    </li>
                ) : null}
                {chair.frame?.texture ? (
                    <li>
                        <span>{`Verarbeitung: ${chair.frame.texture.name}`}</span>
                    </li>
                ) : null}
                {chair.cover ? (
                    <li>
                        <div className={"info-wrapper"}>
                            <div>Bezug:&nbsp;</div>
                            <div className={"info"}>
                                <span>{chair.cover.className}</span>
                                <span>{chair.cover.catalog?.name ? `| ${chair.cover.catalog.name}` : ""}</span>
                                <span>{chair.cover.color?.name ? `| ${chair.cover.color.name}` : ""}</span>
                            </div>
                        </div>
                    </li>
                ) : null}
                {chair.extra ? (
                    <li>
                        <span>{`Zubehör: ${chair.extra.name}`}</span>
                    </li>
                ) : null}
            </ul>

            {info.parent.notes.length > 0 ? (
                <div className={"notes"}>
                    <div className={"notes-info"}>Hinweise:</div>
                    <ul>
                        {globalNote ? (
                            <li className={"note"} style={{ color: globalNote.noteColor, fontWeight: 500 }}>
                                {globalNote.noteText}
                            </li>
                        ) : null}
                        {info.parent.notes.map((note, index) => {
                            return (
                                <li key={index} className={"note"}>
                                    {note.note}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ) : null}

            <ChairInfoButton />
        </>
    );
};

export const CurrentSelection = () => {
    const { chair } = useChair();
    const chairInfoQuery = useGetChairInformation({ id: chair.id });

    const chairInfo = chairInfoQuery.isSuccess ? (chairInfoQuery.data.chairEntries[0] ?? null) : null;

    return <div className={"current-selection"}>{chairInfo ? <ChairInfo chairInfo={chairInfo} /> : null}</div>;
};
